export const login = async (email, password) => {
  try {
    // Lista de usuarios con diferentes configuraciones de colores
    const users = [
      {
        email: 'omnix@email.com',
        password: 'abc123',
        name: 'Usuario 1',
        colores: {
          colorPrincipal: "#700832",
          colorSecundario: "#b68b5b",
          white: "#FFFFFF",
          grisOscuro: "#8F8F8F"
        }
      },
      {
        email: 'usuario2@email.com',
        password: 'pass2',
        name: 'Usuario 2',
        colores: {
          colorPrincipal: "#043c8c",
          colorSecundario: "#f36d18",
          white: "#FFFFFF",
          grisOscuro: "#8F8F8F"
        }
      },
      {
        email: 'usuario3@email.com',
        password: 'pass3',
        name: 'Usuario 3',
        colores: {
          colorPrincipal: "#076653",
          colorSecundario: "#fc6e0f",
          white: "#FFFFFF",
          grisOscuro: "#8F8F8F"
        }
      },
      {
        email: 'usuario4@email.com',
        password: 'pass4',
        name: 'Usuario 4',
        colores: {
          colorPrincipal: "#7226FF",
          colorSecundario: "#f042ff",
          white: "#FFFFFF",
          grisOscuro: "#8F8F8F"
        }
      }
    ];

    // Buscar usuario con las credenciales proporcionadas
    const user = users.find(u => u.email === email && u.password === password);

    if (!user) {
      throw new Error('Credenciales incorrectas');
    }

    // Guardar configuración del usuario en localStorage
    localStorage.setItem('user', JSON.stringify(user));

    // Retornar datos del usuario
    return {
      email: user.email,
      name: user.name,
      colores: user.colores
    };

  } catch (error) {
    throw new Error(error.message || 'Error al iniciar sesión');
  }
};
